import { FuelCardViewModel } from '@ail/orders-api'
import { useCallback, useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import { useDeleteFuelCardMutation, useGetFuelCardsQuery } from '../../../../redux/api/ordersApi'
import { Grid, GridColumn } from '../../../common/Grid/Grid'
import './FuelCardList.scss'
import { Loader } from '../../../common/Loader/Loader'

export function FuelCardList() {
  const fuelCards = useGetFuelCardsQuery()
  const [deleteFuelCard, { isLoading: isDeleting }] = useDeleteFuelCardMutation()
  const loading = fuelCards.isFetching || isDeleting

  const tryDeleteFuelCard = useCallback(
    (id: string) => {
      const agree = window.confirm('Are you sure to delete this item?')
      if (agree) {
        deleteFuelCard(id)
      }
    },
    [deleteFuelCard]
  )

  const renderBrand = useCallback((fuelCard: FuelCardViewModel) => {
    return (
      <div className="fuel-card-brand">
        {fuelCard.key === 'none' ? (
          <i className="icon-fuelcard-no" />
        ) : (
          fuelCard.key.split('-').map((q) => <img src={'/' + q?.toLowerCase().split(' ')[0] + '.svg'} />)
        )}
      </div>
    )
  }, [])

  const renderActions = useCallback(
    (fuelCard: FuelCardViewModel) => {
      return (
        <div className="fuel-card-actions">
          <a>
            <i className="icon-clear" onClick={() => tryDeleteFuelCard(fuelCard.id)} />
          </a>
          <NavLink to={`/RequestsManagement/FuelCards/${fuelCard.id}`}>
            <i className="icon-edit" />
          </NavLink>
        </div>
      )
    },
    [tryDeleteFuelCard]
  )

  const columns = useMemo(() => {
    const result: GridColumn<FuelCardViewModel>[] = [
      {
        key: 'name',
        name: 'Display name',
        sortBy: (f) => f.name,
        renderCell: (p) => p.row.name,
      },
      {
        key: 'key',
        name: 'Key',
        sortBy: (f) => f.key,
        renderCell: (p) => p.row.key,
      },
      {
        key: 'electric',
        name: 'Electric',
        sortBy: (f) => (f.electric ? 0 : 1),
        renderCell: (p) => (
          <i
            style={{ color: p.row.electric ? '#39b54a' : 'red' }}
            className={`icon-${p.row.electric ? 'check' : 'close'}`}
          />
        ),
      },
      {
        key: 'carwash',
        name: 'Car wash',
        sortBy: (f) => (f.carwash ? 0 : 1),
        renderCell: (p) => (
          <i
            style={{ color: p.row.carwash ? '#39b54a' : 'red' }}
            className={`icon-${p.row.carwash ? 'check' : 'close'}`}
          />
        ),
      },
      {
        key: 'supplierIds',
        name: 'Suppliers',
        renderCell: (p) => p.row.supplierIds.join(', ') || '-',
      },
      {
        key: 'brand',
        name: 'Brand',
        renderCell: (p) => renderBrand(p.row),
      },
      {
        key: 'actions',
        name: 'Actions',
        renderCell: (p) => renderActions(p.row),
      },
    ]
    return result
  }, [renderActions, renderBrand])

  return (
    <Loader className="fuel-cards-list" blocking={loading} style={{ overflow: 'hidden' }}>
      <Grid
        renderCustomOption={() => [
          <NavLink className="grid-options-widget" to="/RequestsManagement/FuelCards/new">
            New Fuel Card
          </NavLink>,
          <NavLink className="grid-options-widget" to="/RequestsManagement/GroupFuelCardSets">
            Group Fuel card sets
          </NavLink>,
          <NavLink className="grid-options-widget" to="/RequestsManagement">
            Forms List
          </NavLink>,
          <NavLink className="grid-options-widget" to="/RequestsManagement/Workflows">
            Workflows List
          </NavLink>,
        ]}
        title="Fuel cards"
        icon="icon-fuelcard"
        hideFiltersBtn
        hideReorder
        hideExport
        customClass="fuel-cards-grid"
        id="FuelCards"
        columns={columns}
        rows={fuelCards.currentData ?? []}
        rowKeyGetter={(r) => r.id}
      />
    </Loader>
  )
}
